import { action as apiAction } from 'api/Api'
import {
  set
} from '../redux/cards'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  allowRelationsRemoval?: boolean
}

const requestDeleteCard = (payload: Payload) => async (dispatch, getState) => {
  const { id, allowRelationsRemoval } = payload

  const state = getState()

  const card = state['view-board'].cards[id]

  let optimisticAction
  if (card) {
    optimisticAction = optimisticDispatch(dispatch, set({
      id,
      isBusy: true
    }))
  }

  try {
    await apiAction('RemoveCard', {
      id,
      allowRelationsRemoval
    })

    optimisticAction?.commit()
  } catch (error) {
    if (error.code === 1105) { // Card has relations
      try {
        await sweetalert({
          type: 'warning',
          text: state.kanbo.locale.messages['CARD_DELETE_RELATIONS_EXIST'],
          showCancelButton: true,
          confirmButtonClass: 'btn btn-warning',
          confirmButtonText: state.kanbo.locale.messages['YES'],
          cancelButtonText: state.kanbo.locale.messages['NO']
        })

        optimisticAction?.commit()

        await dispatch(requestDeleteCard({
          ...payload,
          allowRelationsRemoval: true
        }))
      } catch (e) {
        optimisticAction?.revert()
      }
    } else if (error.code === 522) { // Both cards are archived
      optimisticAction?.revert()

      try {
        await sweetalert({
          text: state.kanbo.locale.messages['CARD_DELETE_RELATIONS_ARCHIVED'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}

export default requestDeleteCard
